import React from 'react'
import styles from './Navbar.module.css';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { FaGithub } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { PiMediumLogoFill } from "react-icons/pi";
import { FaInstagram } from "react-icons/fa";
import { pageLinks} from '../data'


const pages = ['About', 'Experience', 'Education', 'Projects', 'Skills', 'Contact'];
const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

function ResponsiveAppBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  // const handleOpenUserMenu = (event) => {
  //   setAnchorElUser(event.currentTarget);
  // };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  // sosyal iconlar ve tıklandığında yeni sayfada açılmasını sağlar
  const handleRedirectToGithub = () => {
    window.open('https://github.com/mrTuranWebDeveloper', '_blank');
  };

  const handleRedirectToLinkedin = () => {
    window.open('https://www.linkedin.com/in/%C3%B6mer-turan-381301282/', '_blank');
  };
  
  const handleRedirectToMedium = () => {
    window.open('https://medium.com/@omerturan00720', '_blank');
  };
  
  const handleRedirectToInstagram = () => {
    window.open('https://www.instagram.com/mrtrn_20_/', '_blank');
  };
  
   // Sayfa adına göre ilgili bölüme yönlendirme işlemi
  
  const handleMenuClick = (page) => {

    if (page === 'About') {
      window.location.href = '#about'; 
    } else if (page === 'Experience') {
      window.location.href = '#experience'; 
    }
      else if (page === 'Education') {
      window.location.href = '#education'; 
    }
      else if (page === 'Projects') {
      window.location.href = '#projects'; 
    }
      else if (page === 'Skills') {
      window.location.href = '#skills'; 
    }
      else if (page === 'Contact') {
      window.location.href = '#contact'; 
    }
    
    handleCloseNavMenu(); // Menüyü kapatmak için
  };

  return (
    <AppBar position="fixed">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
       
        <Typography
            variant="h6"
            noWrap
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            Turan Soft<span className={styles.text} >Ware</span>
        </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
         
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >

            <MenuIcon />
      
            </IconButton>

            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page) => (
    <MenuItem key={page} onClick={() => handleMenuClick(page)}>
      <Typography textAlign="center">{page}</Typography>
    </MenuItem>
              ))}
            </Menu>
          </Box>
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              fontSize: 18,
              letterSpacing: '.1rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            Turan Soft<span className={styles.text} >Ware</span>
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent:'center' }}>
            
            {pageLinks.map((link) => (
              
              <Button
                key={link.id}
                href={link.href}
              
                sx={{ my: 2, color: 'white', display: 'block', p:2 }}
              >
                {link.text}
              </Button>
            ))}
             
          </Box>

          <Box sx={{ flexGrow: 0 }}>
              
              <div className={styles.icons} style={{ display: 'flex', gap: '1rem' }}>
              <FaGithub onClick={handleRedirectToGithub} className={styles.icon} />
              <FaLinkedin onClick={handleRedirectToLinkedin} className={styles.icon} />
              <PiMediumLogoFill onClick={handleRedirectToMedium} className={styles.icon} />
              <FaInstagram onClick={handleRedirectToInstagram} className={styles.icon} />
              </div>
              
            

            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;


            